import RefreshLocationCacheAction from "./RefreshLocationCacheAction.js";
import RefreshLocationCacheDetailModel from "./RefreshLocationCacheDetailModel.js";
import RefreshLocationCacheDetailRenderer from "./RefreshLocationCacheDetailRenderer.js";
import RefreshLocationCacheDetailModelEditor from "./RefreshLocationCacheDetailModelEditor.js";
export default {
  install(molten) {
    molten.addPlugin('Model', {
      type: RefreshLocationCacheDetailModel.TYPE,
      model: RefreshLocationCacheDetailModel
    });
    molten.addPlugin('Detail', {
      name: 'Refresh Location Cache',
      objectType: 'location',
      create: () => RefreshLocationCacheDetailModel.create('location'),
      layout: {
        group: []
      }
    });
    molten.addPlugin('DetailRenderer', {
      type: RefreshLocationCacheDetailModel.TYPE,
      renderer: RefreshLocationCacheDetailRenderer
    });
    molten.addPlugin('ModelEditor', {
      type: RefreshLocationCacheDetailModel.TYPE,
      editor: RefreshLocationCacheDetailModelEditor
    });
    molten.addPlugin('Action', RefreshLocationCacheAction);
  }
};